let info = {
    name: "Muhammad Fidaul Haq",
    logo_name: "feeduck",
    flat_picture: require("./src/assets/feeduck.png"),
    config: {
        use_cookies: true,
        navbar: {
            blur: false
        }
    },
    links: {
        linkedin: "https://www.linkedin.com/in/fidaulhaq/",
        github: "https://github.com/fida501",
        angellist: "https://www.instagram.com/alhaqfida322/",
        resume:
            "#"
    },
    description:
        "My name is Muhammad Fidaul Haq. I'm 21 years old and currently studying at Electronic Engineering Polytechnic Institute of Surabaya majoring Game Technology. I'm a programmer with 6 years combined experience with programming stuff since high school years.<br></<br>" +
        "<br></<br>In my high school years, I mostly learning about the basic of coding, like how the flow and how it works and learning about how to make an android and web application. <br></br> Right now, in my college years, I'm learning about how to develop and make a game. And also learning the advanced code technique such as Design Pattern and Data Structure.  ",
    education: [
        {
            name: "Electronic Engineering Polytechnic Institute of Surabaya",
            place: "Indonesia",
            date: "2022 - Present",
            degree: "Game Technology",
            // gpa: "3.7/4.0",
            description:
                "Study about how to make game. Mostly make the game on the code side and game engine side using unity. Very enthusiastic about learning other technology too such as Unreal Engine and others",
            skills: [
                "Unity",
                "C#",
                "C++",
                "Design Patterns",
                "Data Structures",
                "Algorithms",
            ]
        },
        {
            name: "SMKN 1 Surabaya",
            place: "Indonesia",
            date: "2018 -  2021",
            degree: "Software Engineering",
            // gpa: "8.0/10.0",
            description:
                " Vocational high school in surabaya.  My first jump into programming world. Learn about basic programming, web development, and some other coding related stuff. Mostly trying to understand how code is work.",
            skills: [
                "Java",
                "HTML",
                "CSS",
                "Laravel",
                "XAMPP",
                "PHPMyAdmin",
                "C",
            ]
        }
    ],
    experience: [
        {
            name: "PT Prima Visi Globalindo",
            place: "Surabaya, Indonesia",
            date: "2021 - 2022",
            position: "Programmer",
            description:
                "I work as a Junior Programmer. Helping the senior programmer i work with to make feature that needed by the client. Mostly creating a new page that has a feature about input data and then save it to the database and revise a page that already exist as the client request.",
            skills: ["PHPMaker", "Java", "Tapestry", "DBeaver", "MySQL"]
        },
        {
            name: "Energeek",
            place: "Surabaya, Indonesia",
            date: "2019 - 2020",
            position: "Internship",
            description:
                "Mandatory internship from my vocational high school. Learn about how to make an android application with kotlin, flutter, and also learn bout how to use API and connect it to the app that I made.",
            skills: ["Kotlin", "Android Studio", "Flutter", "API"]
        }
    ],
    skills: [
        {
            title: "languages",
            info: [
                "C#",
                "C++",
                "Java",
                "C",
                "SQL",
                "Kotlin",
            ],
            icon: "fa fa-code"
        },
        // {
        //     title: "data frameworks",
        //     info: [
        //         "Keras",
        //         "Numpy",
        //         "Pandas",
        //         "OpenCV",
        //         "SciPy",
        //         "Sklearn",
        //         "LibROSA",
        //         "Pillow"
        //     ],
        //     icon: "fa fa-cubes"
        // },
        {
            title: "game development",
            info: ["Unity 2D", "Unity 3D", "Unreal Engine", "GameMaker Studio 2"],
            icon: "fa fa-gamepad"
        },
        {
            title: "android and web technologies",
            info: ["Laravel", "PHPMaker", "Tapestry", "HTML", "CSS", "Android Studio", "Flutter"],
            icon: "fas fa-laptop-code"
        },
        // {
        //     title: "operating systems & tools",
        //     info: [
        //         "MacOS",
        //         "Ubuntu",
        //         "Windows",
        //         "Android",
        //         "Agile",
        //         "Scrum",
        //         "JIRA",
        //         "Heroku",
        //         "Firebase",
        //         "AWS S3"
        //     ],
        //     icon: "fas fa-tools"
        // },
        // {
        //     title: "design",
        //     info: ["Illustrator", "XD", "Photoshop", "Final Cut Pro"],
        //     icon: "fa fa-pencil-square-o"
        // }
    ],
    portfolio: [
        {
            name: "Project SEA : Student Exchange Adventure",
            pictures: [
                {
                    img: require("./src/assets/portfolio/wpg2/one.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg2/two.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg2/three.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg2/four.png")
                }, {
                    img: require("./src/assets/portfolio/wpg2/five.png")
                }
            ],
            technologies: ["Unity", "XML", "2D", "Inky", "Quiz"],
            category: "Game Programmer",
            date: "2023",
            github:
                "https://feedduck.itch.io/wpg2projectsea",
            visit: "https://github.com/hrishikeshpaul/music-sheet-recognizer-backend",
            description:
                "Its a game about a middle school student. He hear that the neighbor mocked her mom and he want to avenge that by taking the student exchange. The game about learning english using quiz method and also have a story interaction with the character. The game is made using unity. I working on the programming side. Implementing the mechanic from game design such as basic character movement, Dialogue system using INKY, and the quiz system by deserialize the question and answer XML file from the outside into unity."
        },
        {
            name: "Combatant Chronica",
            pictures: [
                {
                    img: require("./src/assets/portfolio/wpg4/one.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg4/two.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg4/three.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg4/four.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg4/five.png")
                },
                {
                    img: require("./src/assets/portfolio/wpg4/six.png")
                }
            ],
            technologies: ["2.5D", "Shooting", "Platformer", "War", "Unity"],
            category: "Game Programmer",
            date: "2023 - 2024",
            github: "https://feedduck.itch.io/combatant-chronica",
            visit: "https://feedduck.itch.io/combatant-chronica",
            description:
                "A project for Game Production Workshop course which lasts for 2 semester. A 2.5D shooter game about a special forces soldier from the International Peacekeeping Force tasked with escorting a professor on his mission to stabilize an energy source originating from a meteor crater in Slovakia, Europe. I work as a programmer. I implement the game flow and logic that created by the game design. I code the mechanics and systems that created by game design in this game. In this game, I try to implement design patterns such as Finite State Machine for the NPCs and Object Pooling for the bullets to make game more efficient."
        },
        {
            name: "Simulation Game Project with Puspendik",
            pictures: [
                {
                    img: require("./src/assets/portfolio/puspendik/one.png")
                },
                {
                    img: require("./src/assets/portfolio/puspendik/two.png"),
                },
                {
                    img: require("./src/assets/portfolio/puspendik/three.png"),
                },
                {
                    img: require("./src/assets/portfolio/puspendik/four.png"),
                },
                {
                    img: require("./src/assets/portfolio/puspendik/five.png"),
                },
                {
                    img: require("./src/assets/portfolio/puspendik/six.png"),
                }
            ],
            technologies: [
                "Simulation",
                "National Assessment",
                "Government",
                "Puspendik",
                "Unity"
            ],
            category: "Lead Programmer",
            github: "null",
            date: "2024",
            visit: "null",
            description:
                "Project with Pusmendik(Indonesia Educational Assessment Center), making a game about science simulation that needed by the government for national assessment in unity. I working as a Lead Programmer. In collaboration with other roles such as  game design, UI UX, and artist. With UI/UX, I make sure the designed UI can be implemented into unity. With artist, I discuss about the animation that needed and how can i implement the animation into unity. With game design, I discuss about how the game mechanic implemented in unity. besides that, as a lead programmer,  I also need to make standardization for other programmer and checking the other programmer work."
        },
        {
            name: "Monkey Arm Project",
            pictures: [
                {
                    img: require("./src/assets/portfolio/kemendikbud/one.jpg"),
                },
                {
                    img: require("./src/assets/portfolio/kemendikbud/two.png"),
                },
                {
                    img: require("./src/assets/portfolio/kemendikbud/three.png"),
                },
                {
                    img: require("./src/assets/portfolio/kemendikbud/four.png"),
                },
                {
                    img: require("./src/assets/portfolio/kemendikbud/five.png"),
                },
                {
                    img: require("./src/assets/portfolio/kemendikbud/six.png"),
                }

            ],
            technologies: ["Visual Programming", "CSV", "Data Export", "Unity", "2D"],
            category: "Game Programmer",
            date: "2023",
            github: "null",
            visit: "null",
            description:
                "A project with Kemendikbud (Indonesia Ministry of Education and Culture) about a game that can help the student to learn about programming using visual programming. This game is made in unity using blockly as the visual programming tool. . I work as a programmer. In this project, I help my senior export the data that have been saved inside variables and then export it into CSV file. I also help the artist to implement the animation to unity and place it into the game."
        },
        {
            name: "Rusun (C)Emas 2045",
            pictures: [
                {
                    img: require("./src/assets/portfolio/rusuncemas/one.png")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/two.jpeg")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/three.jpeg")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/four.jpeg")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/five.jpeg")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/six.jpeg")
                },
                {
                    img: require("./src/assets/portfolio/rusuncemas/seven.jpeg")
                },

            ],
            technologies: ["3D", "Tower Builder", "Unity", "Casual"],
            category: "Game Programmer",
            date: "2024",
            github: "https://galaxy-rald.itch.io/indonesia-cemas-2045",
            visit: "https://galaxy-rald.itc h.io/indonesia-cemas-2045",
            description:
                "Submission for Compfest Indie Game Ignite. The theme is about future. So we create a tower builder game with the story about that is how house is build in indonesia 2045. I work as a programmer, I code the mechanic of the tower builder, score, main menu interaction."
        },
        {
            name: "Sumber Sehat Simulator",
            pictures: [
                {
                    img: require("./src/assets/portfolio/sumbersehat/one.png")
                },
                {
                    img: require("./src/assets/portfolio/sumbersehat/two.png")
                },
                {
                    img: require("./src/assets/portfolio/sumbersehat/three.png")
                },
                {
                    img: require("./src/assets/portfolio/sumbersehat/four.png")
                },
                {
                    img: require("./src/assets/portfolio/sumbersehat/five.png")
                },
                {
                    img: require("./src/assets/portfolio/sumbersehat/six.jpeg")
                }
            ],
            technologies: ["Simulaton", "Pharmacy", "3D", "First Person POV", "Medicine"],
            category: "Game Programmer",
            github: "null",
            date: "2024",
            visit: "null",
            description:
                'A submission for "Gebyar Startup Jatim 2024" and we got the 1st nomination place in the competition (4th Place). A game that simulate a pharmacy employee. The goal is to serve the customer and give the right medicine. The game is made using unity and the game is in 3D. I working on the programming side. Making the mechanic and the system for the game such as quest system for the player by give the player what medicine that needed to be served, player interaction with object, player serving the customer, customer behaviour, and customer queue.'
        },
        //
        {
            name: "Make Her Laugh",
            pictures: [
                {
                    img: require("./src/assets/portfolio/makeherlaugh/one.png")
                },
                {
                    img: require("./src/assets/portfolio/makeherlaugh/two.png")
                },
                {
                    img: require("./src/assets/portfolio/makeherlaugh/three.png")
                },
                {
                    img: require("./src/assets/portfolio/makeherlaugh/four.png")
                },
                {
                    img: require("./src/assets/portfolio/makeherlaugh/five.png")
                },
                {
                    img: require("./src/assets/portfolio/makeherlaugh/six.png")
                }
            ],
            technologies: ["Horror", "2D", "Story", "Visual Novel", "Psychological"],
            category: "Website",
            github: "https://globalgamejam.org/games/2024/make-her-laugh-8-0",
            date: "2024",
            visit: "https://globalgamejam.org/games/2024/make-her-laugh-8-0",
            description:
                'A Submission for Global Game Jam 2024 located in Surabaya. The theme is "Make Me Laugh", but instead of comedic stuff, we make some horror psychological game to make a twist among the other submission. The game is made in unity, i work as a programmer, im working at the system, combining the mechanic that created by the other programmer. Make the enemy spawner, the jumpscare system, and input some asset to the game.'
        },
        {
            name: "CHAPCHUSH",
            pictures: [
                {
                    img: require("./src/assets/portfolio/chapchush/one.png")
                },
                {
                    img: require("./src/assets/portfolio/chapchush/two.png")
                },
                {
                    img: require("./src/assets/portfolio/chapchush/three.png")
                },
                {
                    img: require("./src/assets/portfolio/chapchush/four.png")
                },
                {
                    img: require("./src/assets/portfolio/chapchush/five.png")
                },
                {
                    img: require("./src/assets/portfolio/chapchush/six.png")
                }
            ],
            technologies: ["Casual", "Crafting", "Collecting Resources", "3D"],
            category: "Website",
            github: "https://feedduck.itch.io/chapchush",
            date: "2024",
            visit: "https://feedduck.itch.io/chapchush",
            description:
                'A submission for GameJamPlus 2024 that runs for 3 days. One of thee theme we pick is Chillax (Chill and relax). So we decided  to make a game about a guy that lost in a island and he need to collect resources such as rock and wood to craft a boat. The game is made in unity. I code all the mechanic and system such as the boat craft , looting gathering resources, win lose condiiton, character movement, character interaction, and the loot object.'
        }
    ],
    // portfolio_design: [
    //     {
    //         name: "Guituna",
    //         title: "Guituna - Mockup Design",
    //         pictures: [
    //             {
    //                 img: require("./src/assets/designs/coursera1/MoodBoard.png"),
    //                 title: "MoodBoard"
    //             },
    //             {
    //                 img: require("./src/assets/designs/coursera1/Mockups 1.png"),
    //                 title: "Mockups 1"
    //             },
    //             {
    //                 img: require("./src/assets/designs/coursera1/Mockups 2.png"),
    //                 title: "Mockups 2"
    //             },
    //             {
    //                 img: require("./src/assets/designs/coursera1/App Elements.png"),
    //                 title: "App Elements"
    //             }
    //         ],
    //         technologies: ["XD", "Illustrator"],
    //         category: "Visual Design",
    //         github: "",
    //         date: "May, 2020 - Jun, 2020",
    //         visit: "",
    //         description:
    //             "Guituna is a simple, lightweight and intuitive guitar tuner, that provides different modes of guitars based on your usage. You can either select a specific string to tune, or free tune your guitar based on the frequency shown on the meter. Guituna also provides a handful of different tunings to help explore various tuning paradigms. There is also an array of settings that can be configured to your liking based on the devices you're using. <br/><br/>The interface aims to highlight the use of a minimal design and providing just enough controls to make for a great tuner, while exposing various possibilities of guitarists to explore."
    //     },
    //     {
    //         name: "Pantree",
    //         title: "Pantree - Mockup Design",
    //         pictures: [
    //             {
    //                 img: require("./src/assets/designs/pantree/MoodBoard.png"),
    //                 title: "Moodboard"
    //             },
    //             {
    //                 img: require("./src/assets/designs/pantree/1.png"),
    //                 title: "Mockups 1"
    //             },
    //             {
    //                 img: require("./src/assets/designs/pantree/2.png"),
    //                 title: "Mockups 2"
    //             }
    //         ],
    //         technologies: ["XD", "Illustrator"],
    //         category: "Visual Design",
    //         github: "",
    //         date: "May, 2020 - July, 2020",
    //         visit: "",
    //         description:
    //             "Pantree is a recipiece finding and recommending application. It is often the case that you have run to your closest grocery store just to pick up one item that is missing in your kitchen. Pantree keeps a track of all your ingredients, and suggests recipes based on your meal preferences and past recipes. <br/><br/> The goal of the interface is to keep it similar to various recipe/food apps to reduce the learning required by the user, but also provide a smooth interface for users to seemlessly browse through recipes and ingredients."
    //     },
    //     {
    //         name: "Bunder",
    //         title: "Bunder - MVP Proposal",
    //         pictures: [
    //             {
    //                 img: require("./src/assets/designs/bunder/Moodboard.png"),
    //                 title: "Moodboard"
    //             },
    //             {
    //                 img: require("./src/assets/designs/bunder/Mockup 1.png"),
    //                 title: "Mockup 1"
    //             },
    //             {
    //                 img: require("./src/assets/designs/bunder/Mockup 2.png"),
    //                 title: "Mockup 2"
    //             },
    //             {
    //                 img: require("./src/assets/designs/bunder/Mockup 3.png"),
    //                 title: "Mockup 3"
    //             },
    //             {
    //                 img: require("./src/assets/designs/bunder/Market Research 1.png"),
    //                 title: "Market Research 1"
    //             },
    //             {
    //                 img: require("./src/assets/designs/bunder/Market Research 2.png"),
    //                 title: "Market Research 2"
    //             }
    //         ],
    //         technologies: ["XD", "Illustrator"],
    //         category: "Visual Design",
    //         github: "",
    //         date: "May, 2020 - July, 2020",
    //         visit: "",
    //         description:
    //             "Bunder is an intuitive web platform for micro-communities to share sensitive data with privacy within the community and allow engagement amongst them. Our aim is two-fold - Co-existing and Collaboration. The former is executed by providing a platform for communities that are geographically positioned in the same proximity (Housing societies, Dorms, Apartment Complexes) to have and share data (exact apartment addresses, phone number, apartment housing rules, individuals tested positive for COVID-19) in an exclusive platform. The latter is to give these people in the community the ability to carry out a task you are physically or remotely unable to do; with dignity and ease."
    //     }
    // ],
    recommendations: [
        {
            title:
                "In his internship, Hrishikesh has demonstrated excellent learning ability, and with a dedicated, task oriented approach, he was able to complete his assignment ahead of time.",
            author: "Ushanas Shastri",
            position: "CTO",
            company: "Viteos Capital Market Services",
            location: "Mumbai"
        },
        {
            title:
                "I feel his budding leadership abilities will become even more effective in a diverse and challenging environment.",
            author: "Anil Dukkipatty",
            position: "CTO",
            company: "Elemential Labs",
            location: "Mumbai"
        },
        {
            title:
                "He has gained great knowledge and experience of SDE, and has learned ot develop the application keeping in mind the client's perpective and also making it creative.",
            author: "Chintan Shah",
            position: "Director",
            company: "Hridayam Soft Solution",
            location: "Mumbai"
        },
        {
            title:
                "During the course of his employment we have found him to be a self-started who was motivated, duty bound and a highly commited team player.",
            author: "Mrinal Pai",
            position: "Co-Founder & Director",
            company: "Skylark Drones",
            location: "Bangalore"
        }
    ]
};

export default info;
